import { createContext, useContext } from "react";

import type { ResolvedTheme, ThemeMode } from "@/lib/theme";

export interface ThemeContextValue {
  /** Выбор пользователя. */
  mode: ThemeMode;
  /** Что реально показано (для `system` — по `prefers-color-scheme`). */
  resolved: ResolvedTheme;
  setMode: (mode: ThemeMode) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme вызван вне <ThemeProvider>");
  return ctx;
}
